export default {"src":"/_next/static/media/finishvlag.50cfd420.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};